import React, {useEffect, useState} from "react"
import {NavLink} from "react-router-dom"
import Loader from "../subsidiary/Loader/Loader"
import ProposalItem from "./components/ProposalItem"
import {useDispatch, useSelector} from "react-redux";
import {fetchProposal} from "./proposalSlice";

const Proposal = () => {
    const dispatch = useDispatch()
    const proposals = useSelector(state => state.proposalSlice.proposal)
    const token = useSelector(state => state.loginSlice.token)
    const [isLoaded, setIsLoaded] = useState(false)
    useEffect(() => {
        dispatch(fetchProposal())
        setTimeout(() => {
            setIsLoaded(true)
        }, 1500);
    }, [dispatch])

    return (
        <>{isLoaded ?
            <>
                <section className="main">
                    <div className="content-wrapper">
                        <div className="page-title-container">
                            <h1 className="page-title ">
                                Акции
                            </h1>
                        </div>
                        <div>
                            {proposals.length > 0 ? proposals.map((row, i) => {
                                return <NavLink key={i.toString()} to={`/proposal/${row.id}`}>
                                    <ProposalItem proposal={row} />
                                </NavLink>
                            }): <div>Акций пока нет</div>}
                        </div>
                    </div>
                </section>
            </>
            : <Loader />}
        </>
    )
}
export default Proposal